import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AdvancedImage } from '@cloudinary/react';
import { Cloudinary } from '@cloudinary/url-gen';
import { scale } from '@cloudinary/url-gen/actions/resize';
import { focusOn } from "@cloudinary/url-gen/qualifiers/gravity";
import { FocusOn } from "@cloudinary/url-gen/qualifiers/focusOn";
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import images from '../../utils/Images';
var FaceImage = function (_a) {
    var publicId = _a.publicId;
    var cld = new Cloudinary({
        cloud: {
            cloudName: process.env.CLOUDINARY_NAME || 'chaseit1416'
        }
    });
    var myImage = cld.image(publicId);
    myImage
        .resize(thumbnail().width(400).height(400).gravity(focusOn(FocusOn.face())))
        .resize(scale().width(50));
    var _b = React.useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    return (_jsxs(_Fragment, { children: [!isLoaded && (_jsx("img", { src: images.userBlue, alt: "" })), _jsx(AdvancedImage, { cldImg: myImage, style: isLoaded ? {} : { display: 'none' }, onLoad: function () { return setIsLoaded(true); }, onError: function () { return setIsLoaded(false); } })] }));
};
export default FaceImage;
